module.exports = __webpack_public_path__ + "img/btn_tap_home_btn.93a137e8.png";